<template>
  <div class="bj-col bj-col-24 ">
    <div v-if="hasBtn" class="tab-btns">
      <!-- 取消物流 -->
      <!-- <el-button v-if="showLogistics && operationType!=2" type="primary" @click="CancelLogistics()">{{ $t('OrdinaryOrderMix.LogisticsTable.cancel') }}</el-button> -->
      <!-- 选择承运商 -->
      <el-dropdown v-if="showSelect && operationType!=2" v-hasDropdownChildren @command="pushOneGoods($event)">
          <!-- 创建售后单按钮 -->
          <el-button type="primary">
            {{ this.$t('InternalSalesOrderDetailsSearchTable.provider') }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in carrierList" :key="index" :command="index" style="width:100px;text-align:center"> {{ item }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
    </div>

    <el-tabs v-model="activeTabIndex" type="card" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('OrdinaryOrderMix.LogisticsTable.Shipment')" name="0">
        <DeliverTable ref="DeliverTable" :has-btn="hasBtn" @haveLogistics="getLogistics" />
      </el-tab-pane>
      <el-tab-pane :label="$t('OrdinaryOrderMix.LogisticsTable.PriceSearchResults')" name="2">
        <SearchTable ref="searchTable" :has-btn="hasBtn" @selectList="getSelectList" />
      </el-tab-pane>
      <el-tab-pane v-if="!$store.getters.cusId" :label="$t('OrdinaryOrderMix.LogiTab.Parcel')" name="3">
        <ParcelNumber ref="ParcelNumber" />
      </el-tab-pane>
    </el-tabs>
    <div class="logistics-price-tip">
      <i class="el-icon-info"></i>
      <span>{{ $t('OrdinaryOrderMix.LogisticsTable.priceReferenceTip') }}</span>
    </div>
  </div>
</template>
<script>
import { afterApi, orderApi, settingApi } from '@/api';
import DeliverTable from './DeliverTable';
import SearchTable from './SearchTable';
import ParcelNumber from './ParcelNumber';
export default {
  components: { DeliverTable, SearchTable, ParcelNumber },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    showEnquiry: {
      type: Boolean,
      default: false
    },
    tabIndex: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      activeTabIndex: this.tabIndex,
      showLogistics: false,
      logisticsBusinessName: null,
      logisticsNo: null,
      showSelect: false,
      carrierList: [
        'AI Selection',
      ],
      operationType: null,
    };
  },
  created() {},
  mounted() {
    this.operationType = this.$route.query.operationType ? this.$route.query.operationType : null;
  },
  methods: {
    handleTabClick(tab) {
      this.$nextTick(() => {
        if (tab.name === '0') {
          this.$refs.DeliverTable && this.$refs.DeliverTable.doLayout();
        } else if (tab.name === '2') {
          this.$refs.searchTable && this.$refs.searchTable.doLayout();
        } else if (tab.name === '3') {
          this.$refs.ParcelNumber && this.$refs.ParcelNumber.doLayout();
        }
      });
    },
    reFreshDeliverTable() {
      this.$refs.DeliverTable.getLogisticsInfo();
    },
    // BigText Push To Sap
    pushToSap() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          orderApi
            .pushToSapOrder({ orderCode: this.dataInfo.orderInfoVO.innerOrderNo })
            .then(() => {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
            });
        })
        .catch(_ => {});
    },

    // 获取是否有物流信息
    getLogistics(res) {
      // 子页面传过来的参数 ==> res.logisticsNo,res.logisticsBusinessName
      // console.log(res, '物流信息');

      if (res) {
        this.showLogistics = true;
        this.logisticsBusinessName = res.logisticsBusinessName;
        this.logisticsNo = res.logisticsNo;
      }
    },

    // 取消物流按钮
    CancelLogistics() {
      if (this.logisticsNo) {
        orderApi.cancelInternalLogistics({ logisticsBusinessName: this.logisticsBusinessName, logisticsNo: this.logisticsNo });
      }
      // this.$confirm(this.$t('InternalSalesOrderDetails.want'))
      //   .then(_ => {
      //     orderApi
      //       .cancelInternalLogistics({ logisticsBusinessName: this.logisticsBusinessName, logisticsNo: this.logisticsNo })
      //       .then(res => {
      //         if (res.failed === false) {
      //           this.$message.success(this.$t('toast.operationSuccessText'));
      //           setTimeout(() => {
      //             this.reFresh();
      //           }, 500);
      //         }
      //       });
      //   })
      //   .catch(_ => {});
    },

    // 确认物流按钮回传值给页面上的展示页面中的物品展示页面中的物流
    getSelectList(data) {
      this.carrierList.push(...data);
    },
    // 控制展示订单发货按钮
    openSelect() {
      if (this.carrierList.length > 1) {
        this.showSelect = true;
      } else {
        this.$message.warning(this.$t('OrdinaryOrderMix.GoodsInfoTab.ps3'));
      }
    },

    // 选择承运商发货按钮
    pushOneGoods(e) {
      if (this.dataInfo.unfinishedTotalVO.outStockCount != 0) return this.$message.warning(this.$t('OrdinaryOrderMix.GoodsInfoTab.ps1'));
      if (this.dataInfo.unfinishedTotalVO.preempAuditCount < 1) return this.$message.warning(this.$t('OrdinaryOrderMix.GoodsInfoTab.ps2'));
      afterApi.pushOneGoodsApi({
        orderCode: this.$route.query.code,
        // 物流商
        provider: this.carrierList[e] == 'AI Selection' ? '' : this.carrierList[e]
      })
      .then(() => {
        this.$message.success(this.$t('toast.operationSuccessText'));
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.tab-btns {
  display: inline-block;
  position: absolute;
  right: 60px;
  margin-top: 4px;
  z-index: 1;
}
.logistics-price-tip {
  display: flex;
  align-items: center;
  margin-top: 16px;
  color: #303133;
  font-size: 14px;
  line-height: 20px;

  .el-icon-info {
    margin-right: 8px;
  }
}
</style>
